import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import type { InjectionKey } from 'vue';
import type { UserManagerSettings } from 'oidc-client-ts';

export type UserManagerContextType = {
  userManager: UserManager;
  createUserManager(value: UserManagerSettings): UserManager;
};

const SCOPES = [
  'ime_api',
  'proto_api',
  'agent_api',
  'sad_api',
  'market_api',
  'fund_api',
  'tse_api',
  'base_api',
  'market_api',
  'profile',
  'srvdsk_api',
  'tse_profile',
  'openid',
  'offline_access',
];

const OIDC_CONFIG: UserManagerSettings = {
  authority: 'https://account.irfarabi.com',
  client_id: import.meta.env.VITE_APP_OIDC_CLIENT_ID,
  response_type: 'code',
  scope: SCOPES.join(' '),
  post_logout_redirect_uri: `${window.location.origin}`,
  redirect_uri: `${window.location.origin}/auth/callback`,
  silent_redirect_uri: `${window.location.origin}/auth/renew`,
  filterProtocolClaims: true,
  automaticSilentRenew: false,
  extraQueryParams: {
    login_type: 'password',
    idp: 'farabixo',
  },
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
  checkSessionIntervalInSeconds: 2000,
  monitorSession: true,
};

const UserManagerSymbol: InjectionKey<UserManagerContextType> =
  Symbol('UserManagerContext');

export { OIDC_CONFIG, UserManagerSymbol };
